import { FC, SVGProps } from "react";

export const Vessel: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg {...props} version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
      <path d="m577.5 375h45v45h-45z" />
      <path d="m705 375h45v45h-45z" />
      <path d="m450 375h45v45h-45z" />
      <path d="m867.45 810 62.551-225-90-24.602v-181.8c0.48438-20.371-7.1484-40.098-21.215-54.84-14.066-14.742-33.414-23.289-53.785-23.762h-142.5v-60h52.5v-45h-150v45h52.5v60h-142.5c-20.371 0.47266-39.719 9.0195-53.785 23.762-14.066 14.742-21.699 34.469-21.215 54.84v181.8l-90 24.602 62.551 225h-152.55v45h840v-45zm-462.45-270v-161.4c-0.44922-8.4297 2.4492-16.691 8.0703-22.988 5.6211-6.293 13.504-10.109 21.93-10.613h330c8.4258 0.50391 16.309 4.3203 21.93 10.613 5.6211 6.2969 8.5195 14.559 8.0703 22.988v169.65l-195-53.25-195 53.25zm-79.5 76.5 252-68.699v262.2h-198.3zm297 193.5v-262.2l252 68.699-53.699 193.5z" />
      <path d="m255 885h690v45h-690z" />
      <path d="m330 960h540v45h-540z" />
    </svg>
  );
};
